import { METAL_SHINE } from "../shared/achievements";
import { byId } from "./dom";
import { locale, t } from "./i18n";
import { awardsNow, boardNow, loadAwards, onAwards } from "./awards_store";
import { modLimit, onRackTuned } from "./home_rack";
import { showView } from "./navigation";
import { medalDef } from "./medal_art";
import { miniMedal, shownDirt } from "./medal_case";
import { rankRow } from "./views/achievements_view";

// the leaderboard and medal shelf on home

function paintLeaders(): void {
  const summary = awardsNow();
  const board = boardNow();
  const limit = modLimit("leaders");
  const rows = board.slice(0, limit).map(rankRow);
  const mine = board.findIndex((entry) => entry.you);
  // someone below the cut still sees where they stand
  if (mine >= limit) rows.push(rankRow(board[mine], mine));
  byId("leaders-list").replaceChildren(...rows);
  byId("leaders-empty").hidden = board.length > 0;
  byId("leaders-score").textContent = summary ? t("{n} points", { n: summary.points.toLocaleString(locale()) }) : "";
}

function paintMedals(): void {
  const summary = awardsNow();
  if (!summary) return;
  const held = summary.medals.filter((medal) => medal.earned && medalDef(medal.id))
    .sort((first, second) => shownDirt(second) - shownDirt(first) || METAL_SHINE[medalDef(second.id)!.metal] - METAL_SHINE[medalDef(first.id)!.metal]);
  byId("medals-shelf").replaceChildren(...held.slice(0, 4).map((medal) => {
    const tile = document.createElement("button");
    tile.type = "button";
    tile.className = "mini-medal";
    const name = t(medalDef(medal.id)!.name);
    tile.setAttribute("aria-label", `${name}, ${shownDirt(medal) <= 0.02 ? t("fully polished") : t("needs polish")}`);
    const label = document.createElement("span");
    label.className = "medal-name";
    label.textContent = name;
    tile.append(miniMedal(medal, 56)!, label);
    tile.addEventListener("click", () => showView("achievements", "medals"));
    return tile;
  }));
  byId("medals-empty").hidden = held.length > 0;
  const dirty = held.filter((medal) => shownDirt(medal) > 0.3).length;
  byId("medals-dirty").textContent = dirty ? t("{n} need a polish", { n: dirty }) : held.length ? t("all shining") : "";
}

export function setupAwardsModules(): void {
  byId("leaders-open").addEventListener("click", () => showView("achievements", "ranks"));
  byId("medals-open").addEventListener("click", () => showView("achievements", "medals"));
  onAwards(() => {
    paintLeaders();
    paintMedals();
  });
  onRackTuned(() => {
    paintLeaders();
    paintMedals();
  });
  void loadAwards();
}
